import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NumeroCompte } from 'src/app/app.models';
import { Subscription } from 'rxjs';
import { NumeroCompteService } from 'src/app/services/numero-compte.service';

@Component({
  selector: "app-mon-porte-monaie",
  templateUrl: "./mon-porte-monaie.component.html",
  styleUrls: ["./mon-porte-monaie.component.scss"],
})
export class MonPorteMonaieComponent implements OnInit, OnDestroy {

  //Subscription
  numeroCompteSubscription: Subscription;

  public infoFormPorteMonaie!: UntypedFormGroup;
  public userIn: any;
  //indicatif France et Dom Tom 262,689,687,681,508,269,594,596,590,33
  phonePattern = "^((\\+262-?)|(\\+689-?)|(\\+687-?)|(\\+681-?)|(\\+508-?)|(\\+269-?)|(\\+594-?)|(\\+596-?)|(\\+590-?)|(\\+33-?))[8|9|6|7][0-9]{8}$";


  numeroCompte: NumeroCompte;
  dataShow: boolean = false;

  constructor(
    public formBuilder: UntypedFormBuilder,
    private toastr: ToastrService,
    private numeroCompteService: NumeroCompteService,
    public router: Router
  ) { }

  ngOnInit() {

    const storageAuth = localStorage.getItem("user");

    if (storageAuth) {

      this.userIn = JSON.parse(storageAuth);

      this.getNumeroCompteOfUser();

    } else {

      this.router.navigate(['login']);

    }
    
  }

  initForm() {
    
    this.infoFormPorteMonaie = this.formBuilder.group({
      operateur: [this.numeroCompte.numero_compte_operateur, Validators.required],
      phone_number: [this.numeroCompte.numero_compte_phone_number, Validators.compose([Validators.required, Validators.pattern(this.phonePattern)])],
    });

  }

  getNumeroCompteOfUser() {

    this.numeroCompteSubscription = this.numeroCompteService.numeroCompteOfUser(this.userIn.id).subscribe((response: any) => {

      this.dataShow = true;

      if(response.numeroCompte) {

        this.numeroCompte = response.numeroCompte;

      } else {

        this.numeroCompte = new NumeroCompte({});

      }

      this.initForm(); 

    })
  }
  

  public onInfoFormPorteMonaieSubmit(): void {

    if(this.infoFormPorteMonaie.status == "INVALID") {

      this.toastr.error("Votre Fomulaire est incomplet");

    }else {

      let numeroCompte : NumeroCompte = {
        id: this.numeroCompte.id,
        user_id : this.userIn.id,
        numero_compte_phone_number: this.infoFormPorteMonaie.value.phone_number,
        numero_compte_operateur : this.infoFormPorteMonaie.value.operateur
      }

      this.numeroCompteSubscription =  this.numeroCompteService.create(numeroCompte).subscribe((data) => {
        
        this.toastr.success('Le numéro a été enregistré avec success');
        
        history.back();

      });
      
    }
  }

  ngOnDestroy(): void {
    
    if(this.dataShow) {

      this.numeroCompteSubscription.unsubscribe();

    }

  }

}